/**
 * What the four kinds of brief are called.
 *
 * Two names each, deliberately: the long one introduces a brief ("Dnevni
 * ritam"), the short one numbers it in the sequence ("Brief #16"). Path
 * and the detail screen both read from here so the same brief never calls
 * itself one thing in the list and another at the top of its own page.
 */

export const KIND_LABELS = {
  brief: 'Daily rhythm',
  episode: 'Episode',
  mission: 'Mission',
  info: 'Practical',
}

const SEQUENCE_LABELS = {
  brief: 'Brief',
  episode: 'Episode',
  mission: 'Mission',
  info: 'Practical',
}

/**
 * "Misija #6", or "Osobno" for a brief written for one person — those sit
 * outside the shared count — or the bare kind when there is no number, which is
 * what a locked point looks like: it carries no kind, so it is simply "Brief".
 */
export function sequenceName(entry) {
  if (entry.personal) {
    return 'Osobno'
  }

  const label = SEQUENCE_LABELS[entry.kind] ?? 'Brief'

  return entry.number ? `${label} #${entry.number}` : label
}
